
















































































































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import isPast from 'date-fns/isPast/index';
import isFuture from 'date-fns/isFuture/index';
import { useConfirmDialog } from '@vueuse/core';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import BaseDivider from '@front-app/components/layouts/BaseDivider.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ConfirmationModal from '@front-app/components/modals/ConfirmationModal.vue';
import { FullDigest } from '../model';
import { useDigestsStore } from '../store/GroupDigests';
import ScheduleLabel from './ScheduleLabel.vue';
import OnOffLabel from './OnOffLabel.vue';
import StatusBadge from './StatusBadge.vue';

export default defineComponent({
	components: {
		SimpleCard,
		ScheduleLabel,
		BaseDivider,
		CtaButton,
		OnOffLabel,
		StatusBadge,
		ConfirmationModal,
	},
	props: {
		digest: {
			type: Object as PropType<FullDigest>,
			required: true,
		},
	},
	setup(props) {
		const {
			track,
			isLoading,
		} = useAsyncStatus();
		const activate = () => {
			track(useDigestsStore().setDeactivation(props.digest.groupId, props.digest.id, false));
		};
		const deactivateConfirmationModal = useConfirmDialog();
		const deactivate = async () => {
			const { isCanceled } = await deactivateConfirmationModal.reveal();
			if (isCanceled) {
				return;
			}
			track(useDigestsStore().setDeactivation(props.digest.groupId, props.digest.id, true));
		};
		const hasEnded = computed(() => {
			if (!props.digest.endDate) {
				return false;
			}
			return isPast(new Date(props.digest.endDate));
		});
		const willStart = computed(() => {
			if (!props.digest.startDate) {
				return false;
			}
			return isFuture(new Date(props.digest.startDate));
		});
		return {
			hasEnded,
			willStart,
			isLoading,
			activate,
			deactivate,
			deactivateConfirmationModal,
			ButtonPalettes,
		};
	},
});
